import { Theme, ColorHues } from '@chakra-ui/react';
import { reduce } from 'lodash';

const path = `${process.env.PUBLIC_URL}/static/media/`;

export const imageSrc = {
  cdCover: `${path}cd-cover.png`,
  cdCoverSong: `${path}song-cover-cd.png`,
  songCoverBig: `${path}song-cover-big.png`,
};

export const getAvatarColorsArray = (theme: Theme) => [
  theme.colors.orange,
  theme.colors.pink,
  theme.colors.purple,
  theme.colors.yellow,
  theme.colors.blue,
];

const getStringASCIISum = (value: string) =>
  reduce(value, (acc, val) => acc + val.charCodeAt(0), 0);

export const getRandomColor = (colors: ColorHues[], value?: string) =>
  colors[getStringASCIISum(value || '') % colors.length];
